// extracted by mini-css-extract-plugin
export var aircallIframe = "_eo-3";
export var fabContainer = "_eo-5";
export var fabRinging = "_eo-6";
export var loadingOverlay = "_eo-4";
export var pulse = "_eo-7";
export var widgetContent = "_eo-2";
export var widgetPanel = "_eo-0";
export var widgetPanelExpanded = "_eo-1";